import React, { Component, Fragment } from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getArizonaData } from "../../actions/arizonadataActions";

class TableArizonaWeekly extends Component {
  componentDidMount() {
    this.props.getArizonaData();
  }
  render() {
    // MANUAL AQUÍ
    var labelsData = [
      "Arizona Epidemiological Week 13 (03/22 - 03/28)",
      "Arizona Epidemiological Week 14 (03/29 - 04/04)",
      "Arizona Epidemiological Week 15 (04/05 - 04/11)",
      "Arizona Epidemiological Week 16 (04/12 - 04/18)",
      "Arizona Epidemiological Week 17 (04/19 - 04/25)",
      "Arizona Epidemiological Week 18 (04/26 - 05/02)",
      "Arizona Epidemiological Week 19 (05/03 - 05/09)",
      "Arizona Epidemiological Week 20 (05/10 - 05/16)",
      "Arizona Epidemiological Week 21 (05/17 - 05/23)",
      "Arizona Epidemiological Week 22 (05/24 - 05/30)",
      "Arizona Epidemiological Week 23 (05/31 - 06/06)",
      "Arizona Epidemiological Week 24 (06/07 - 06/13)",
      "Arizona Epidemiological Week 25 (06/14 - 06/20)",
      "Arizona Epidemiological Week 26 (06/21 - 06/27)",
      "Arizona Epidemiological Week 27 (06/28 - 07/04)",
      "Arizona Epidemiological Week 28 (07/05 - 07/11)",
      "Arizona Epidemiological Week 29 (07/12 - 07/18)",
      "Arizona Epidemiological Week 30 (07/19 - 07/25)",
      "Arizona Epidemiological Week 31 (07/26 - 08/01)",
      "Arizona Epidemiological Week 32 (08/02 - 08/08)",
      "Arizona Epidemiological Week 33 (08/09 - 08/15)",
      "Arizona Epidemiological Week 34 (08/16 - 08/22)",
      "Arizona Epidemiological Week 35 (08/23 - 08/29)",
      "Arizona Epidemiological Week 36 (08/30 - 09/05)",
      "Arizona Epidemiological Week 37 (09/06 - 09/12)",
      "Arizona Epidemiological Week 38 (09/13 - 09/19)",
      "Arizona Epidemiological Week 39 (09/20 - 09/26)",
      "Arizona Epidemiological Week 40 (09/27 - 10/03)",
      "Arizona Epidemiological Week 41 (10/04 - 10/10)",
      "Arizona Epidemiological Week 42 (10/11 - 10/17)",
      "Arizona Epidemiological Week 43 (10/18 - 10/24)",
      "Arizona Epidemiological Week 44 (10/25 - 10/31)",
      "Arizona Epidemiological Week 45 (11/01 - 11/07)",
      "Arizona Epidemiological Week 46 (11/08 - 11/14)",
      "Arizona Epidemiological Week 47 (11/15 - 11/21)",
      "Arizona Epidemiological Week 48 (11/22 - 11/28)",
      "Arizona Epidemiological Week 49 (11/29 - 12/05)",
      "Arizona Epidemiological Week 50 (12/06 - 12/12)",
      "Arizona Epidemiological Week 51 (12/13 - 12/19)",
      "Arizona Epidemiological Week 52 (12/20 - 12/26)",
      "Arizona Epidemiological Week 53 (12/27 - 01/02)",
      "Arizona Epidemiological Week 54 (01/03 - 01/09)",
      "Arizona Epidemiological Week 55 (01/10 - 01/16)",
      "Arizona Epidemiological Week 56 (01/17 - 01/23)",
      "Arizona Epidemiological Week 57 (01/24 - 01/30)",
      "Arizona Epidemiological Week 58 (01/31 - 02/06)",
      "Arizona Epidemiological Week 59 (02/07 - 02/13)",
      "Arizona Epidemiological Week 60 (02/14 - 02/20)",
      "Arizona Epidemiological Week 61 (02/21 - 02/27)",
      "Arizona Epidemiological Week 62 (02/28 - 03/06)",
      "Arizona Epidemiological Week 63 (03/07 - 03/13)",
      "Arizona Epidemiological Week 64 (03/14 - 03/20)",
      "Arizona Epidemiological Week 65 (03/21 - 03/27)",
      "Arizona Epidemiological Week 66 (03/28 - 04/03)",
      "Arizona Epidemiological Week 67 (04/04 - 04/10)",
      "Arizona Epidemiological Week 68 (04/11 - 04/17)",
      "Arizona Epidemiological Week 69 (04/18 - 04/24)",
      "Arizona Epidemiological Week 70 (04/25 - 05/01)",
      "Arizona Epidemiological Week 71 (05/02 - 05/08)",
      "Arizona Epidemiological Week 72 (05/09 - 05/15)",
      "Arizona Epidemiological Week 73 (05/16 - 05/22)",
      "Arizona Epidemiological Week 74 (05/23 - 05/39)",
      "Arizona Epidemiological Week 75 (05/30 - 06/05)",
      "Arizona Epidemiological Week 76 (06/06 - 06/12)",
      "Arizona Epidemiological Week 77 (06/13 - 06/19)",
      "Arizona Epidemiological Week 78 (06/20 - 06/26)",
      "Arizona Epidemiological Week 79 (06/27 - 07/03)",
      "Arizona Epidemiological Week 80 (07/04 - 07/10)",
      "Arizona Epidemiological Week 81 (07/11 - 07/17)",
      "Arizona Epidemiological Week 82 (07/18 - 07/24)",
      "Arizona Epidemiological Week 83 (07/25 - 07/31)",
      "Arizona Epidemiological Week 84 (08/01 - 08/07)",
      "Arizona Epidemiological Week 85 (08/08 - 08/14)",
      "Arizona Epidemiological Week 86 (08/15 - 08/21)",
      "Arizona Epidemiological Week 87 (08/22 - 08/28)",
      "Arizona Epidemiological Week 88 (08/29 - 09/04)",
      "Arizona Epidemiological Week 89 (09/05 - 09/11)",
      "Arizona Epidemiological Week 90 (09/12 - 09/18)",
      "Arizona Epidemiological Week 91 (09/19 - 09/25)",
      "Arizona Epidemiological Week 92 (09/26 - 10/02)",
      "Arizona Epidemiological Week 93 (10/03 - 10/09)",
      "Arizona Epidemiological Week 94 (10/10 - 10/16)",
      "Arizona Epidemiological Week 95 (10/17 - 10/23)",
      "Arizona Epidemiological Week 96 (10/24 - 10/30)",
      "Arizona Epidemiological Week 97 (10/31 - 11/06)",
      "Arizona Epidemiological Week 98 (11/07 - 11/13)",
      "Arizona Epidemiological Week 99 (11/14 - 11/20)",
      "Arizona Epidemiological Week 100 (11/21 - 11/27)",
      "Arizona Epidemiological Week 101 (11/28 - 12/04)",
      "Arizona Epidemiological Week 102 (12/05 - 12/11)",
      "Arizona Epidemiological Week 103 (12/12 - 12/18)",
      "Arizona Epidemiological Week 104 (12/19 - 12/25)",
      "Arizona Epidemiological Week 105 (12/26 - 01/01)",
    ];

    var labels = [];
    const dataSize = this.props.arizonadatas.length;
    const { arizonadatas } = this.props;

    if (dataSize % 7 === 0) {
      for (var l = 0; l < dataSize / 7; l++) {
        labels.push(labelsData[l]);
      }
    } else {
      for (l = 0; l < Math.floor(dataSize / 7) + 1; l++) {
        labels.push(labelsData[l]);
      }
    }

    labels = labels.reverse();

    var arr = [];
    var avgs = [];
    for (var x = 0; x < dataSize / 7; x++) {
      arr[x] = [];
    }
    for (var i = 0; i < dataSize; i++) {
      if (i % 7 === 0) {
        var sum = 0;
        var divisor = 0;
        if (arizonadatas[i] !== undefined) {
          arr[i / 7].push(arizonadatas[i]);
          divisor++;
          sum =
            sum + parseFloat(arizonadatas[i].new_cases_today.replace(/,/g, ""));
        }
        if (arizonadatas[i + 1] !== undefined) {
          arr[i / 7].push(arizonadatas[i + 1]);
          divisor++;
          sum =
            sum +
            parseFloat(arizonadatas[i + 1].new_cases_today.replace(/,/g, ""));
        }
        if (arizonadatas[i + 2] !== undefined) {
          arr[i / 7].push(arizonadatas[i + 2]);
          divisor++;
          sum =
            sum +
            parseFloat(arizonadatas[i + 2].new_cases_today.replace(/,/g, ""));
        }
        if (arizonadatas[i + 3] !== undefined) {
          arr[i / 7].push(arizonadatas[i + 3]);
          divisor++;
          sum =
            sum +
            parseFloat(arizonadatas[i + 3].new_cases_today.replace(/,/g, ""));
        }
        if (arizonadatas[i + 4] !== undefined) {
          arr[i / 7].push(arizonadatas[i + 4]);
          divisor++;
          sum =
            sum +
            parseFloat(arizonadatas[i + 4].new_cases_today.replace(/,/g, ""));
        }
        if (arizonadatas[i + 5] !== undefined) {
          arr[i / 7].push(arizonadatas[i + 5]);
          divisor++;
          sum =
            sum +
            parseFloat(arizonadatas[i + 5].new_cases_today.replace(/,/g, ""));
        }
        if (arizonadatas[i + 6] !== undefined) {
          arr[i / 7].push(arizonadatas[i + 6]);
          divisor++;
          sum =
            sum +
            parseFloat(arizonadatas[i + 6].new_cases_today.replace(/,/g, ""));
        }

        var average = (Math.round((sum / divisor + Number.EPSILON) * 100) / 100)
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

        avgs.push(average);
      }
    }
    avgs = avgs.reverse();
    return (
      <>
        <div className="row my-4">
          <div className="col-md-12">
            <div className="nav py-3 border-bottom-gray">
              <div className="tabs">
                <Link to="/" className="tab tab-inactive">
                  Arizona Daily
                </Link>
                <Link to="/arizona" className="tab tab-inactive">
                  Arizona Daily
                </Link>
                <Link to="/pima-weekly" className="tab tab-inactive">
                  Arizona Weekly
                </Link>
                <Link to="/arizona-weekly" className="tab ">
                  Arizona Weekly
                </Link>
              </div>
            </div>
          </div>
        </div>
        <h1>Arizona 7 Day Average</h1>
        <br />
        {arr.reverse().map((data, a) => (
          <Fragment key={a}>
            <h3>{labels[a]}</h3>
            <br />
            <Table>
              <Thead>
                <Tr>
                  <Th>Date</Th>
                  <Th># Cases</Th>
                  <Th>New Cases</Th>
                </Tr>
              </Thead>
              <Tbody>
                {data.map((point, b) => (
                  <Fragment key={b}>
                    <Tr>
                      <Td>
                        {point.date.month}/{point.date.day}
                      </Td>
                      <Td>
                        {point.number_of_cases
                          .replace(/,/g, "")
                          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
                      </Td>
                      <Td>
                        {point.new_cases_today
                          .replace(/,/g, "")
                          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
                      </Td>
                    </Tr>
                  </Fragment>
                ))}
              </Tbody>
            </Table>
            <h5 className="text-right">Weekly Average: {avgs[a]}</h5>
            <br />
            <br />
          </Fragment>
        ))}
      </>
    );
  }
}

TableArizonaWeekly.propTypes = {
  getArizonaData: PropTypes.func.isRequired,
  arizonadatas: PropTypes.array.isRequired,
};
const mapStateToProps = (state) => ({
  arizonadatas: state.arizonadata.arizonadatas,
});

export default connect(mapStateToProps, { getArizonaData })(TableArizonaWeekly);
